@if (isTooSmall()) {
  <div class="screen-guard" data-test-id="screen-size-guard">
    <article class="screen-guard__content">
      <img
        class="screen-guard__image"
        src="assets/icons/generic-ko.svg"
        alt=""
      />
      <p class="screen-guard__title" data-test-id="screen-guard-title">
        {{ 'screen_size_title' | translate }}
      </p>
      <div class="screen-guard__messages" data-test-id="screen-guard-description">
        <p>{{ 'screen_size_message_1' | translate }}</p>
        <br />
        <p>{{ 'screen_size_message_2' | translate }}</p>
        <br />
        <p>{{ 'screen_size_message_3' | translate }}</p>
      </div>
    </article>
  </div>
}
